import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPixV2 = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Vector",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M7.54378 0.944169C8.98329 -0.356664 11.2051 -0.313285 12.5926 1.07405L18.9256 7.40706C20.3578 8.83922 20.3578 11.1614 18.9256 12.5936L12.5926 18.9256C11.1608 20.3574 8.83884 20.3574 7.40707 18.9256L1.07406 12.5926C-0.358035 11.1605 -0.358003 8.83922 1.07406 7.40706L7.40707 1.07405L7.54378 0.944169ZM11.1785 2.48811C10.5274 1.83714 9.47218 1.83705 8.82113 2.48811L2.48812 8.82112C1.83711 9.47223 1.83708 10.5275 2.48812 11.1785L8.82113 17.5116C9.47185 18.1623 10.5278 18.1623 11.1785 17.5116L17.5116 11.1785C18.1624 10.5274 18.1626 9.47216 17.5116 8.82112L11.1785 2.48811Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.22738 4.99983C6.92978 4.99983 7.58917 5.29919 8.06332 5.80745L9.99886 7.88069L11.9364 5.80745C12.4107 5.3001 13.0698 4.99983 13.7723 4.99983H14.9998V6.99983H13.7723C13.6463 6.99983 13.5091 7.05226 13.3973 7.17171L13.3983 7.17268L11.283 9.43733C10.5825 10.1875 9.417 10.1866 8.71664 9.43733L6.6014 7.17268L6.60042 7.17171C6.48962 7.05305 6.35358 6.99983 6.22738 6.99983H4.99984V4.99983H6.22738Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.71664 10.5623C9.37322 9.85988 10.4385 9.81515 11.1463 10.4305L11.283 10.5623L13.3983 12.827C13.5101 12.9465 13.6463 12.9998 13.7723 12.9998H14.9998V14.9998H13.7723C13.0698 14.9998 12.4107 14.7005 11.9364 14.1932L9.99886 12.118L8.06332 14.1922C7.58918 14.7005 6.92978 14.9998 6.22738 14.9998H4.99984V12.9998H6.22738C6.35358 12.9998 6.48962 12.9466 6.60042 12.828L6.6014 12.827L8.71664 10.5623Z",
				fill: "currentColor"
			})
		]
	})
});
export default SvgPixV2;
